import { Event } from "event-system";
import { Container, FederatedPointerEvent, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { ButtonWithScaleAndPosYAnimation } from "../../../../common/components/ButtonWithScaleAndPosYAnimation";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { WalletDisconnectionResourcePackage } from "../../resources/WalletDisconnectionResourcePackage";

export class WalletDisconnectionContainer extends Container {
    private confirmButton: ButtonWithScaleAndPosYAnimation;
    private declineButton: ButtonWithScaleAndPosYAnimation;

    public get onConfirmButtonClick(): Event<ButtonWithScaleAndPosYAnimation, FederatedPointerEvent> {
        return this.confirmButton.onUp;
    }

    public get onDeclineButtonClick(): Event<ButtonWithScaleAndPosYAnimation, FederatedPointerEvent> {
        return this.declineButton.onUp;
    }

    public constructor(walletDisconnectionResources: WalletDisconnectionResourcePackage, commonResources: CommonResourcesPackage) {
        super();
        const frame = new Sprite(walletDisconnectionResources.assets_views_wallet_disconnection_frame_png);
        this.addChild(frame);
        const descriptionText = new Text(`ARE YOU SURE YOU WANT TO`, new DescriptionTextStyle());
        descriptionText.position.set(83, 148);
        this.addChild(descriptionText);
        const disconnectText = new Text(`DISCONNECT`, new DescriptionTextStyle());
        disconnectText.style.fill = ["#fe4e4b", "#ff07b4"];
        disconnectText.style.fillGradientType = 1;
        disconnectText.position.set(458, 148);
        this.addChild(disconnectText);
        const yourText = new Text(`YOUR`, new DescriptionTextStyle());
        yourText.position.set(144, 193);
        this.addChild(yourText);
        const walletText = new Text(`WALLET`, new DescriptionTextStyle());
        walletText.style.fill = ["#d81fee", "#9906fc"];
        walletText.position.set(220, 193);
        this.addChild(walletText);
        const additionalText = new Text(`FROM THE GAME?`, new DescriptionTextStyle());
        additionalText.position.set(331, 193);
        this.addChild(additionalText);
        this.confirmButton = new ButtonWithScaleAndPosYAnimation(commonResources.assets_common_ui_button_green_png);
        this.confirmButton.position.set(38.5, 328.5);
        this.confirmButton.width = 305.42;
        this.confirmButton.height = 156.46;
        this.addChild(this.confirmButton);
        const confirmButtonText = new Text(`YES`, new ButtonTextStyle());
        confirmButtonText.position.set(148, 42);
        this.confirmButton.defaultView.addChild(confirmButtonText);
        this.declineButton = new ButtonWithScaleAndPosYAnimation(commonResources.assets_common_ui_button_orange_png);
        this.declineButton.position.set(369.5, 328.5);
        this.declineButton.width = 296.42;
        this.declineButton.height = 147.46;
        this.addChild(this.declineButton);
        const declineButtonText = new Text(`NO`, new ButtonTextStyle());
        declineButtonText.position.set(147, 41);
        this.declineButton.defaultView.addChild(declineButtonText);
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 44
        }));
    }
}


class ButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 0.5,
            dropShadowBlur: 5,
            dropShadowDistance: 4,
            fontSize: 57,
            leading: 15
        }));
    }
}
